import DOMPurify from 'dompurify';

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'u', 'b', 'i', 's', 'del', 'ins', 'mark', 'sub', 'sup',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'ul', 'ol', 'li',
    'a', 'img',
    'blockquote', 'code', 'pre',
    'table', 'thead', 'tbody', 'tr', 'th', 'td',
    'div', 'span', 'section', 'article', 'figure', 'figcaption',
    'hr', 'small', 'abbr', 'cite', 'q', 'dfn', 'time',
    'dl', 'dt', 'dd',
    'video', 'source', 'iframe',
  ],
  ALLOWED_ATTR: [
    'href', 'src', 'alt', 'title', 'class', 'style', 'id', 'name',
    'target', 'rel', 'width', 'height', 'loading', 'decoding',
    'type', 'controls', 'autoplay', 'muted', 'loop', 'poster',
    'allowfullscreen', 'frameborder', 'allow',
    'colspan', 'rowspan', 'scope',
    'datetime',
  ],
  ALLOW_DATA_ATTR: true,
  ADD_ATTR: ['target'],
};

/**
 * Sanitize HTML content to prevent XSS attacks.
 */
export function sanitizeHtml(dirty: string | null | undefined): string {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, SANITIZE_CONFIG) as string;
}
